import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Home";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Editor from "@/pages/Editor";
import Reader from "@/pages/Reader";
import Admin from "@/pages/Admin";
import Contact from "@/pages/Contact";
import { useEffect } from "react";
import { loadGA } from "@/lib/tracking";
import { LoaderScreen } from "@/components/BrandLoader";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <LoaderScreen label="Loading iBookStudio" testid="auth-loading" />;
  if (!user) return <Navigate to="/" replace />;
  return children;
};

const AppRouter = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/editor/:bookId" element={<Protected><Editor /></Protected>} />
      <Route path="/preview/:bookId" element={<Protected><Reader mode="preview" /></Protected>} />
      <Route path="/admin" element={<Protected><Admin /></Protected>} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/read/:slug" element={<Reader mode="read" />} />
      <Route path="/embed/:slug" element={<Reader mode="embed" />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default function App() {
  useEffect(() => { loadGA(); }, []);
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster theme="dark" position="bottom-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}
